import playerStatsPlayIndexes from '@/data/player/playerStatsPlayIndexes';
import getTeamsStatPlayIndexes from '@/data/team/teamStatsPlayIndexes';
import router from '@/router';
import { regularLeague, cup, cupLegacyAbb } from '@/utils/play-off-abbreviations';
const playerPlayIndexes = playerStatsPlayIndexes();
const teamPlayIndexes = getTeamsStatPlayIndexes();
const cupSeasonsIds = [1784, 1741, 1512, 881];

export default {
  namespaced: true,
  state: {
    sections: [],
    results: [],
    playingAs: null,
    seasonId: null,
    seasonType: 0, // 0 regular season, 1 playoffs
    categoryType: null,
    seasons: [],
    stadisticId: 1, // Establecer por defecto 0 = Promedio por Partido 1 = Totales
    playsForGames: [],
    seasonTeamsMap: new Map(),
    seasonGamesMap: new Map(),
    selectedGamesIds: [],
    analysisType: 1,
    teamId: 0,
    tournamentsForMediaPlayer: new Map(),
    hasPlayerNationalTeam: false,
    hasPlayerClubSeasons: true,
    isPlayerNationalTeam: false,
  },
  getters: {
    getSections: state => state.sections,
    getResults: state => state.results,
    getPlayingAs: state => state.playingAs,
    getCategoryType: state => state.categoryType,
    getSeasons: state => state.seasons,
    getSeasonId(state, getter, rootState, rootGetters) {
      let seasonSelected = window.localStorage.getItem('seasonSelected');
      if (seasonSelected) {
        seasonSelected = Number(seasonSelected);
      }
      const defaultSeasonId = seasonSelected || rootGetters['loginGeneral/seasonId'];
      return state.seasonId || defaultSeasonId;
    },

    isPlayersAnalysis: () => router.app._route.name === 'player',
    getGamesPlayed(state, getter, rootState, rootGetters) {
      const STADISTIC_ID = getter.getStadisticId;
      const PLAYER = rootGetters['playersGeneral/player'];
      const GOALKEEPER_POSITION_ID = 1;
      const POSITION_ID = PLAYER ? PLAYER.position_id : null;
      const PLAYERS = rootGetters['playersGeneral/seasonPlayers'].filter(p => {
        let add = POSITION_ID === null ? p.position_id !== GOALKEEPER_POSITION_ID : false;
        if (POSITION_ID) {
          add =
            POSITION_ID === GOALKEEPER_POSITION_ID
              ? p.position_id === GOALKEEPER_POSITION_ID
              : p.position_id !== GOALKEEPER_POSITION_ID;
        }
        return add;
      }).length;
      // todo: check if the results are ok without TEAMS
      const TEAMS = rootGetters['teamsGeneral/teamsForAnalysis'].length;
      //Stadistic_id helps to select if data should be total or average
      if (STADISTIC_ID === 0) {
        const GAMES = rootGetters['gamesGeneral/seasonGamesPlayed'];
        return (GAMES.filter(game => game.game_status !== 0).length * PLAYERS) / TEAMS;
      } else {
        return PLAYERS;
      }
    },
    getGamesPlayedByTeam(state, getter, rootState, rootGetters) {
      const STADISTIC_ID = getter.getStadisticId;
      // Stadistic_id helps to select if data should be total or average
      if (STADISTIC_ID === 0) {
        if (getter.isPlayersAnalysis) {
          return Object.keys(
            [
              ...rootGetters['playersPossession/getBasePlaysStack'],
              ...rootGetters['playersOffensive/getBasePlaysStack'],
              ...rootGetters['playersDefensive/getBasePlaysStack'],
            ]
              .filter(p => (state.playingAs === null ? true : p[playerPlayIndexes.playingAs] === state.playingAs))
              .filter(p => state.results.includes(p[playerPlayIndexes.matchResult]))
              .reduce((a, b) => {
                a[b[playerPlayIndexes.gameId]] = [...(a[b[playerPlayIndexes.gameId]] || []), b];
                return a;
              }, {}),
          ).length;
        }
        const GAMES = rootGetters['gamesGeneral/seasonGamesPlayed'];
        const TEAM_ID = rootGetters['teamsGeneral/team'].team_id;

        return GAMES.filter(game => game.game_status !== 0)
          .filter(game => {
            let add;
            if (state.playingAs === null) add = game.home_team === TEAM_ID || game.visiting_team === TEAM_ID;
            else if (state.playingAs === 1) add = game.home_team === TEAM_ID;
            else add = game.visiting_team === TEAM_ID;
            return add;
          })
          .filter(game => {
            const IS_HOME = game.home_team === TEAM_ID;
            let result = 1;
            if ((game.score[0] > game.score[1] && !IS_HOME) || (game.score[0] < game.score[1] && IS_HOME)) result = 2;
            else if (game.score[0] === game.score[1]) result = 3;
            return state.results.includes(result);
          }).length;
      } else {
        return 1;
      }
    },
    getGamesPlayedByPlayer: (state, getters) => (playerBasePlays, usePlayerIndex = false) => {
      if (getters.getStadisticId === 0) {
        if (playerBasePlays) {
          const indexes = usePlayerIndex ? playerPlayIndexes : teamPlayIndexes;
          return Object.keys(
            playerBasePlays.reduce((a, b) => {
              if (
                (state.playingAs === null || b[indexes.playingAs] === state.playingAs) &&
                state.results.includes(b[indexes.matchResult])
              ) {
                a[b[indexes.gameId]] = [...(a[b[indexes.gameId]] || []), b];
              }
              return a;
            }, {}),
          ).length;
        }
        return 0;
      }
      return 1;
    },
    getStadisticId: state => state.stadisticId,
    getCategoryTypeName(state) {
      let name;
      switch (state.categoryType) {
        case 1:
          name = 'posesion';
          break;
        case 2:
          name = 'ofensivo';
          break;
        case 3:
          name = 'defensivo';
          break;
      }
      return name;
    },
    getSelectedGamesIds(state) {
      return state.selectedGamesIds;
    },
    isCup(state, getters) {
      return cupSeasonsIds.includes(getters.getSeasonId);
    },
    availableGames(state, getters) {
      const playIndexes = state.analysisType === 1 ? playerPlayIndexes : teamPlayIndexes;
      const gamesIds = state.playsForGames.reduce((accumulator, play) => {
        if (!accumulator.has(play[playIndexes.gameId])) {
          const isTeamPlay = play[playIndexes.teamId] === state.teamId;
          if (
            state.results.includes(play[playIndexes.matchResult]) &&
            (state.analysisType === 1 || isTeamPlay) &&
            (!state.playingAs || state.playingAs === play[playIndexes.playingAs])
          ) {
            const game = state.seasonGamesMap.get(play[playIndexes.gameId]);
            if (game) {
              let isOwnPlay = !(state.analysisType === 2 && play[playIndexes.teamId] !== state.teamId);
              const rivalTeamId = isOwnPlay
                ? play[playIndexes.playingAs] === 1
                  ? game.visiting_team
                  : game.home_team
                : play[playIndexes.playingAs] === 1
                ? game.home_team
                : game.visiting_team;
              const rivalTeam = state.seasonTeamsMap.get(rivalTeamId);
              let roundAbbreviation = '';
              const roundNumberString = game.matchday_abbreviation.replace('M', '');
              const defaultName = `J${roundNumberString}`;
              if (game.seasonType === 0) {
                if (getters.isCup) {
                  if (getters.getSeasonId === 881) {
                    roundAbbreviation = cupLegacyAbb[roundNumberString] || defaultName;
                  } else {
                    roundAbbreviation = cup[game.matchday_abbreviation] ? game.matchday_abbreviation : defaultName;
                  }
                } else {
                  roundAbbreviation = defaultName;
                }
              } else if (game.seasonType === 1) {
                roundAbbreviation = regularLeague[game.matchday_abbreviation];
              } else {
                if (game.matchday_id === 182) {
                  roundAbbreviation = 'PI1';
                } else if (game.matchday_id === 183) {
                  roundAbbreviation = 'PI2';
                } else {
                  roundAbbreviation = game.matchday_abbreviation.replace('PO', 'R');
                }
              }
              accumulator.set(play[playIndexes.gameId], {
                id: play[playIndexes.gameId],
                isSelected: true,
                dateTimeMillis: game.dateTimeMillis,
                rivalTeam,
                roundAbbreviation,
              });
            }
          }
        }
        return accumulator;
      }, new Map());
      const availableGamesArray = Array.from(gamesIds.values());
      availableGamesArray.sort((a, b) => a.dateTimeMillis - b.dateTimeMillis);
      return availableGamesArray;
    },
  },
  mutations: {
    setIsPlayerNationalTeam(state, isPlayerNationalTeam = false) {
      state.isPlayerNationalTeam = isPlayerNationalTeam;
    },
    setHasPlayerNationalTeam(state, hasPlayerNationalTeam = false) {
      state.hasPlayerNationalTeam = hasPlayerNationalTeam;
    },
    setHasPlayerClubSeasons(state, hasPlayerClubSeasons = true) {
      state.hasPlayerClubSeasons = hasPlayerClubSeasons;
    },
    setTournamentsForMediaPlayer(state, tournamentsForMediaPlayer) {
      state.tournamentsForMediaPlayer = tournamentsForMediaPlayer;
    },
    setAnalysisType(state, analysisType) {
      state.analysisType = analysisType;
    },
    setTeamId(state, teamId) {
      state.teamId = teamId;
    },
    setSelectedGamesIds(state, selectedGamesIds) {
      state.selectedGamesIds = selectedGamesIds;
    },
    setSeasonTeamsMap(state, seasonTeamsMap) {
      state.seasonTeamsMap = seasonTeamsMap;
    },
    setSeasonGamesMap(state, seasonGamesMap) {
      state.seasonGamesMap = seasonGamesMap;
    },
    /**
     * @author José Rafael Gutierrez
     * @param state
     * @param sections
     */
    setSections: (state, sections) => {
      state.sections = sections;
    },
    /**
     * @author José Rafael Gutierrez
     * @param state
     * @param results
     */
    setResults: (state, results) => {
      state.results = results;
    },
    /**
     * @author José Rafael Gutierrez
     * @param state
     * @param playingAs
     */
    setPlayingAs: (state, playingAs) => {
      state.playingAs = playingAs;
    },
    /**
     * @author José Rafael Gutierrez
     * @param state
     * @param seasonId
     */
    setSeasonId: (state, seasonId) => {
      state.seasonId = Number(seasonId);
    },
    /**
     * @author José Rafael Gutierrez
     * @param state
     * @param categoryType
     */
    setCategoryType: (state, categoryType) => {
      state.categoryType = categoryType;
    },
    /**
     * @author Alejandro
     * @param {Object} state
     * @param {Array<{id: number, name: string}>} seasons
     */
    setSeasons(state, seasons) {
      state.seasons = seasons;
    },
    /**
     * @author Cristhian Gómez
     * @param {Object} state
     * @param {number} stadisticId
     */
    setStadisticId: (state, stadisticId) => {
      state.stadisticId = stadisticId;
    },
    /**
     * @author Alejandro Martinez
     * @param {Object} state
     * @param {number} seasonType - Values can be 0 for regular season and 1 for playoffs
     */
    setSeasonType(state, seasonType) {
      state.seasonType = seasonType;
    },
    setPlaysForGames(state, playsForGames) {
      state.playsForGames = playsForGames;
    },
  },
  actions: {
    /**
     * @author Alejandro
     * @param {Object} context
     * @param {Object} payload
     * @param {Object} payload.seasons - Available seasons for selected team or player, object is a dictionary
     * in the form { "seasonId": "seasonName" }
     */
    updateSeasons({ state, commit }, { seasons }) {
      if (seasons) {
        const tournamentsForMediaPlayer = new Map();
        const unorderedSeasons = Object.entries(seasons).reduce((accumulator, [k, v]) => {
          const keyNumber = Number(k);
          const tournament = {
            _id: keyNumber,
            id: keyNumber,
            name: v.name,
            tournament: {
              tournament_type: cupSeasonsIds.includes(keyNumber),
            },
            seasons: [
              {
                id: keyNumber,
                related_seasons: [],
                type: 0,
              },
            ],
          };
          tournamentsForMediaPlayer.set(keyNumber, tournament);
          accumulator.push({ id: keyNumber, name: v.name, type: v.type });
          return accumulator;
        }, []);
        commit('setTournamentsForMediaPlayer', tournamentsForMediaPlayer);
        commit(
          'setSeasons',
          unorderedSeasons.sort((a, b) => {
            return b.id - a.id;
          }),
        );
        if (unorderedSeasons.length) {
          let seasonId = window.localStorage.getItem('seasonSelected') || unorderedSeasons[0].id;
          seasonId = Number(seasonId);
          let defaultSeason = unorderedSeasons.find(season => season.id === seasonId);
          commit('setSeasonId', defaultSeason ? seasonId : unorderedSeasons[0].id);
          commit('setSeasonType', unorderedSeasons.find(season => season.id === state.seasonId).type);
        }
      }
    },
  },
};
